export const movies = [
  {
    id: "m1",
    title: "流浪地球3",
    year: "2025",
    type: "movie",
    category: "科幻",
    region: "中国大陆",
    director: "林寒",
    actors: ["吴京", "屈楚萧", "李雪健"],
    rating: "9.2",
    tags: ["科幻", "灾难", "家国"],
    description:
      "太阳系危机再度升级，人类联合政府启动“流浪地球”计划的最终阶段。面对即将失控的行星发动机与内部分歧，一群原本普通的工程师与宇航员被推上历史舞台，用勇气与牺牲守护这颗蓝色星球最后的希望。",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20sci-fi%20movie%20key%20art%2C%20lone%20astronaut%20standing%20before%20a%20colossal%20glowing%20blue%20earth%20horizon%2C%20drifting%20debris%20and%20cold%20starlight%2C%20epic%20blockbuster%20poster%20style%2C%20dramatic%20volumetric%20lighting%2C%20ultra%20detailed%20vertical%20composition%2C%20moody%20atmospheric%20depth&width=500&height=750&seq=mv-m1-91peach&orientation=portrait",
  },
  {
    id: "m2",
    title: "满江红·惊蛰",
    year: "2025",
    type: "movie",
    category: "古装",
    region: "中国大陆",
    director: "张远",
    actors: ["易烊千玺", "雷佳音", "王传君"],
    rating: "8.6",
    tags: ["悬疑", "古装", "权谋"],
    description:
      "南宋年间，一桩离奇命案牵动朝堂。小人物在权谋漩涡中步步为营，用一次次看似荒诞的选择，逼近那个被所有人刻意掩埋的真相。影片以精巧的结构与克制的表演，讲述了一段关于信念与代价的故事。",
    cover:
      "https://readdy.ai/api/search-image?query=elegant%20ancient%20chinese%20costume%20drama%20movie%20poster%2C%20mysterious%20palace%20corridor%20lit%20by%20red%20lanterns%2C%20silhouettes%20of%20swordsmen%20in%20flowing%20robes%2C%20cinematic%20warm%20amber%20and%20deep%20crimson%20lighting%2C%20detailed%20period%20key%20art%2C%20vertical%20composition&width=500&height=750&seq=mv-m2-91peach&orientation=portrait",
  },
  {
    id: "m3",
    title: "孤勇者",
    year: "2024",
    type: "movie",
    category: "动作",
    region: "中国香港",
    director: "陈木胜",
    actors: ["甄子丹", "刘德华"],
    rating: "8.9",
    tags: ["动作", "犯罪", "兄弟"],
    description:
      "一名被组织抛弃的卧底，在雨夜的霓虹街头独自面对昔日的兄弟与敌人。拳拳到肉的动作设计与克制的情绪表达相互交织，勾勒出江湖边缘人物身不由己的宿命感。",
    cover:
      "https://readdy.ai/api/search-image?query=gritty%20action%20thriller%20movie%20poster%2C%20determined%20man%20in%20a%20leather%20jacket%20walking%20through%20a%20rain-soaked%20neon%20city%20street%2C%20dramatic%20rim%20light%2C%20high%20contrast%20noir%20tones%2C%20dynamic%20cinematic%20energy%2C%20vertical%20key%20art&width=500&height=750&seq=mv-m3-91peach&orientation=portrait",
  },
  {
    id: "m4",
    title: "春日告白",
    year: "2025",
    type: "movie",
    category: "爱情",
    region: "中国大陆",
    director: "许安然",
    actors: ["周迅", "刘昊然"],
    rating: "8.3",
    tags: ["爱情", "治愈", "成长"],
    description:
      "樱花盛开的小城里，两个对生活失去热情的人因为一次偶然的错过而相遇。那些没能说出口的话，在漫长的春天里慢慢发酵，最终成为各自人生中最温柔的一次告白。",
    cover:
      "https://readdy.ai/api/search-image?query=tender%20romantic%20drama%20movie%20poster%2C%20young%20couple%20sharing%20an%20umbrella%20under%20blooming%20cherry%20blossom%20trees%20at%20golden%20hour%2C%20soft%20warm%20pastel%20tones%2C%20gentle%20bokeh%2C%20dreamy%20film%20still%20aesthetic%2C%20vertical%20composition&width=500&height=750&seq=mv-m4-91peach&orientation=portrait",
  },
  {
    id: "m5",
    title: "深空回响",
    year: "2025",
    type: "movie",
    category: "科幻",
    region: "美国",
    director: "诺兰·凯",
    actors: ["马修·麦康纳", "安妮·海瑟薇"],
    rating: "8.8",
    tags: ["科幻", "悬疑", "太空"],
    description:
      "一支探险队抵达气态行星环带深处，却发现那里矗立着一座不属于任何已知文明的几何体。随着信号不断回响，队员们开始怀疑，真正被探索的其实是他们自己。",
    cover:
      "https://readdy.ai/api/search-image?query=deep%20space%20science%20fiction%20movie%20poster%2C%20mysterious%20glowing%20geometric%20monolith%20floating%20above%20a%20dark%20planet%20ring%20system%2C%20cold%20cyan%20and%20violet%20nebula%20light%2C%20cerebral%20cinematic%20key%20art%2C%20ultra%20detailed%20vertical%20composition&width=500&height=750&seq=mv-m5-91peach&orientation=portrait",
  },
  {
    id: "m6",
    title: "长安幻夜",
    year: "2024",
    type: "movie",
    category: "奇幻",
    region: "中国大陆",
    director: "郭凡",
    actors: ["王一博", "宋轶"],
    rating: "8.1",
    tags: ["奇幻", "古装", "冒险"],
    description:
      "上元灯节的长安城，一名少年画师意外唤醒了沉睡千年的神兽。当繁华的灯火与传说中的妖异交织，他必须在一夜之间解开古老封印，守护整座城池的安宁。",
    cover:
      "https://readdy.ai/api/search-image?query=fantasy%20ancient%20chinese%20epic%20movie%20poster%2C%20giant%20mythical%20creature%20soaring%20above%20the%20illuminated%20ancient%20palace%20at%20night%2C%20swirling%20clouds%20and%20golden%20sparks%2C%20vibrant%20cinematic%20key%20art%2C%20detailed%20vertical%20composition&width=500&height=750&seq=mv-m6-91peach&orientation=portrait",
  },
  {
    id: "m7",
    title: "迷雾追凶",
    year: "2025",
    type: "movie",
    category: "悬疑",
    region: "中国大陆",
    director: "曹保平",
    actors: ["段奕宏", "张译"],
    rating: "8.7",
    tags: ["悬疑", "犯罪", "人性"],
    description:
      "一桩尘封多年的旧案，因为一通匿名电话重新浮出水面。老刑警与新搭档在层层迷雾中追查真相，却发现每个证人都在说谎，而谎言背后藏着一段被时间掩埋的往事。",
    cover:
      "https://readdy.ai/api/search-image?query=tense%20crime%20mystery%20movie%20poster%2C%20lone%20detective%20standing%20in%20thick%20fog%20on%20a%20deserted%20mountain%20road%20with%20a%20single%20streetlight%2C%20muted%20grey%20green%20palette%2C%20moody%20thriller%20key%20art%2C%20cinematic%20vertical%20composition&width=500&height=750&seq=mv-m7-91peach&orientation=portrait",
  },
  {
    id: "m8",
    title: "极速狂飙",
    year: "2024",
    type: "movie",
    category: "动作",
    region: "美国",
    director: "詹姆斯·李",
    actors: ["范·迪塞尔", "杰森·斯坦森"],
    rating: "7.9",
    tags: ["动作", "赛车", "热血"],
    description:
      "退役车手为救回被绑架的弟弟重出江湖，一场横跨三座城市的午夜竞速就此展开。引擎的轰鸣、灯光的残影与兄弟间的情义，在极限速度中碰撞出最酣畅的火花。",
    cover:
      "https://readdy.ai/api/search-image?query=high%20octane%20racing%20action%20movie%20poster%2C%20sleek%20supercars%20drifting%20through%20a%20neon%20lit%20city%20tunnel%20at%20night%2C%20motion%20blur%20and%20sparks%2C%20vibrant%20orange%20and%20teal%20lighting%2C%20blockbuster%20key%20art%2C%20dynamic%20vertical%20composition&width=500&height=750&seq=mv-m8-91peach&orientation=portrait",
  },
];

export const tvshows = [
  {
    id: "t1",
    title: "都市夜归人",
    year: "2025",
    type: "tvshow",
    category: "都市",
    region: "中国大陆",
    director: "李牧",
    actors: ["童瑶", "王凯", "谭卓"],
    rating: "8.5",
    tags: ["都市", "情感", "群像"],
    description:
      "深夜的城市里，四个不同职业的年轻人因为一场意外聚在同一栋公寓。他们各自背负着生活的压力与秘密，在彼此的交集中慢慢学会与这座城市和解。",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20urban%20drama%20series%20poster%2C%20young%20office%20worker%20walking%20through%20a%20glowing%20city%20at%20night%20with%20reflections%20on%20wet%20pavement%2C%20warm%20street%20light%20and%20cool%20shadows%2C%20emotional%20cinematic%20tone%2C%20vertical%20composition&width=500&height=750&seq=tv-t1-91peach&orientation=portrait",
  },
  {
    id: "t2",
    title: "长夜未央",
    year: "2025",
    type: "tvshow",
    category: "古装",
    region: "中国大陆",
    director: "周砚",
    actors: ["刘诗诗", "成毅", "张彬彬"],
    rating: "8.8",
    tags: ["古装", "权谋", "爱情"],
    description:
      "身负家族使命的女子入宫为质，在波谲云诡的后宫与朝堂之间步步为营。她用智慧化解一次次危机，也在权谋的尽头，遇见了那个愿意为她放弃所有算计的人。",
    cover:
      "https://readdy.ai/api/search-image?query=ancient%20chinese%20palace%20drama%20series%20poster%2C%20elegant%20lady%20in%20hanfu%20standing%20in%20a%20moonlit%20courtyard%20with%20falling%20snow%2C%20deep%20blue%20night%20and%20warm%20lantern%20glow%2C%20poetic%20cinematic%20key%20art%2C%20vertical%20composition&width=500&height=750&seq=tv-t2-91peach&orientation=portrait",
  },
  {
    id: "t3",
    title: "风暴之眼",
    year: "2024",
    type: "tvshow",
    category: "悬疑",
    region: "中国大陆",
    director: "五百",
    actors: ["秦昊", "王砚辉", "任素汐"],
    rating: "9.0",
    tags: ["悬疑", "罪案", "心理"],
    description:
      "一座海边小城连续发生失踪案，所有线索都指向十年前那场被遗忘的风暴。刑警队长在调查中逐渐发现，真相就藏在每个人不愿提起的那一夜。",
    cover:
      "https://readdy.ai/api/search-image?query=suspense%20thriller%20series%20poster%2C%20stormy%20dark%20clouds%20over%20a%20lone%20lighthouse%2C%20a%20figure%20looking%20into%20the%20distance%2C%20moody%20teal%20grey%20palette%2C%20dramatic%20cinematic%20tension%2C%20vertical%20composition&width=500&height=750&seq=tv-t3-91peach&orientation=portrait",
  },
  {
    id: "t4",
    title: "山海图志",
    year: "2025",
    type: "tvshow",
    category: "奇幻",
    region: "中国大陆",
    director: "滕华涛",
    actors: ["许凯", "白鹿", "陈飞宇"],
    rating: "8.4",
    tags: ["奇幻", "冒险", "神话"],
    description:
      "一部失传的古卷重新现世，书中记载的山海异兽竟逐一显现人间。年轻的守护者必须穿越现实与传说的边界，阻止一场足以颠覆世界的浩劫。",
    cover:
      "https://readdy.ai/api/search-image?query=mythical%20fantasy%20series%20poster%2C%20ancient%20scroll%20world%20with%20floating%20mountains%20and%20legendary%20beasts%20among%20glowing%20clouds%2C%20vivid%20jade%20and%20gold%20tones%2C%20detailed%20epic%20key%20art%2C%20vertical%20composition&width=500&height=750&seq=tv-t4-91peach&orientation=portrait",
  },
  {
    id: "t5",
    title: "破晓行动",
    year: "2025",
    type: "tvshow",
    category: "刑侦",
    region: "中国大陆",
    director: "陈育新",
    actors: ["张译", "黄景瑜", "李乃文"],
    rating: "8.6",
    tags: ["刑侦", "缉毒", "硬核"],
    description:
      "一支临时组建的特别行动队，为捣毁跨境犯罪网络展开为期四十天的卧底行动。在黎明来临之前，他们要面对的不只是敌人，还有随时可能崩塌的信任。",
    cover:
      "https://readdy.ai/api/search-image?query=police%20procedural%20series%20poster%2C%20team%20of%20detectives%20in%20dark%20tactical%20gear%20gathered%20under%20pale%20dawn%20light%2C%20gritty%20realistic%20tone%2C%20cinematic%20crime%20drama%20key%20art%2C%20vertical%20composition&width=500&height=750&seq=tv-t5-91peach&orientation=portrait",
  },
  {
    id: "t6",
    title: "医者仁心",
    year: "2024",
    type: "tvshow",
    category: "医疗",
    region: "中国大陆",
    director: "郑晓龙",
    actors: ["靳东", "海清", "李佳航"],
    rating: "8.2",
    tags: ["医疗", "职场", "温情"],
    description:
      "急诊科里每天都在上演生死时速。一群性格各异的医生在一次次抢救中并肩成长，也在一场场告别中重新理解生命的分量。",
    cover:
      "https://readdy.ai/api/search-image?query=medical%20drama%20series%20poster%2C%20doctor%20in%20white%20coat%20standing%20in%20a%20bright%20hospital%20corridor%20at%20sunrise%2C%20hopeful%20warm%20light%2C%20clean%20modern%20composition%2C%20emotional%20cinematic%20key%20art%2C%20vertical%20composition&width=500&height=750&seq=tv-t6-91peach&orientation=portrait",
  },
  {
    id: "t7",
    title: "时光信使",
    year: "2025",
    type: "tvshow",
    category: "科幻",
    region: "中国大陆",
    director: "路阳",
    actors: ["雷佳音", "杨紫", "朱一龙"],
    rating: "8.7",
    tags: ["科幻", "温情", "穿越"],
    description:
      "一个能收到未来来信的邮差，开始尝试改写别人的遗憾。可当他试图挽回自己的过去时，却发现每一封信的背后，都牵动着另一段未曾预料的命运。",
    cover:
      "https://readdy.ai/api/search-image?query=mild%20sci-fi%20series%20poster%2C%20person%20receiving%20a%20glowing%20letter%20that%20unravels%20into%20floating%20light%20particles%2C%20dreamy%20warm%20and%20cyan%20tones%2C%20gentle%20cinematic%20key%20art%2C%20vertical%20composition&width=500&height=750&seq=tv-t7-91peach&orientation=portrait",
  },
  {
    id: "t8",
    title: "烟火人间",
    year: "2024",
    type: "tvshow",
    category: "生活",
    region: "中国大陆",
    director: "孔笙",
    actors: ["闫妮", "张嘉益", "宋丹丹"],
    rating: "8.9",
    tags: ["生活", "家庭", "治愈"],
    description:
      "老城区的一条小巷里，三代人围绕着一家小面馆展开柴米油盐的日常。平淡的日子里藏着最真实的欢喜与牵挂，也让观众看见生活本身的力量。",
    cover:
      "https://readdy.ai/api/search-image?query=slice%20of%20life%20series%20poster%2C%20warm%20family%20gathering%20around%20a%20dinner%20table%20with%20steam%20rising%20and%20cozy%20lamp%20light%2C%20soft%20amber%20tones%2C%20tender%20realistic%20key%20art%2C%20vertical%20composition&width=500&height=750&seq=tv-t8-91peach&orientation=portrait",
  },
];

export const shows = [
  {
    id: "s1",
    title: "舌尖中国行",
    year: "2025",
    type: "show",
    category: "美食",
    region: "中国大陆",
    director: "陈晓卿",
    actors: ["李立宏"],
    rating: "9.1",
    tags: ["美食", "纪录", "人文"],
    description:
      "跟随镜头走过大江南北，在烟火升腾的厨房与街巷里，寻找那些被时间与手艺共同守护的味道，也记录下食物背后一个个鲜活的人生。",
    cover:
      "https://readdy.ai/api/search-image?query=food%20travel%20variety%20show%20poster%2C%20steaming%20bowls%20of%20regional%20chinese%20cuisine%20on%20a%20rustic%20wooden%20table%20with%20warm%20lantern%20light%2C%20appetizing%20editorial%20photography%2C%20cozy%20warm%20tones%2C%20vertical%20composition&width=500&height=750&seq=sh-s1-91peach&orientation=portrait",
  },
  {
    id: "s2",
    title: "歌手对决",
    year: "2025",
    type: "show",
    category: "音乐",
    region: "中国大陆",
    director: "洪涛",
    actors: ["何炅", "华晨宇", "那英"],
    rating: "8.7",
    tags: ["音乐", "竞技", "live"],
    description:
      "顶级唱将同台竞演，每一期都是一场不容失误的现场考验。舞台之上，音乐之外，是歌手们对自我极限的不断突破。",
    cover:
      "https://readdy.ai/api/search-image?query=music%20competition%20show%20poster%2C%20singer%20silhouetted%20on%20a%20grand%20stage%20with%20spotlights%20and%20a%20cheering%20crowd%2C%20dramatic%20purple%20and%20gold%20stage%20lighting%2C%20energetic%20concert%20key%20art%2C%20vertical%20composition&width=500&height=750&seq=sh-s2-91peach&orientation=portrait",
  },
  {
    id: "s3",
    title: "声临其境",
    year: "2024",
    type: "show",
    category: "声音",
    region: "中国大陆",
    director: "徐晴",
    actors: ["张国立", "王俊凯", "韩雪"],
    rating: "8.5",
    tags: ["声音", "表演", "经典"],
    description:
      "用声音重塑经典片段，演员们以台词与情感为武器，在看不见的舞台上一较高下。一句台词，一段回忆，声音的魅力在此被无限放大。",
    cover:
      "https://readdy.ai/api/search-image?query=voice%20performance%20show%20poster%2C%20vintage%20microphone%20in%20a%20recording%20studio%20with%20glowing%20sound%20waves%2C%20warm%20amber%20and%20teal%20accent%20light%2C%20artistic%20cinematic%20key%20art%2C%20vertical%20composition&width=500&height=750&seq=sh-s3-91peach&orientation=portrait",
  },
  {
    id: "s4",
    title: "我们的客栈",
    year: "2025",
    type: "show",
    category: "生活",
    region: "中国大陆",
    director: "王征宇",
    actors: ["黄磊", "何炅", "张子枫"],
    rating: "8.3",
    tags: ["慢综艺", "治愈", "田园"],
    description:
      "在群山环抱的乡野客栈里，嘉宾们亲手经营一方小院。远离喧嚣的日子，让每个人都在一次次相遇中找回久违的松弛感。",
    cover:
      "https://readdy.ai/api/search-image?query=slow%20life%20variety%20show%20poster%2C%20cozy%20countryside%20inn%20with%20wooden%20porch%20surrounded%20by%20green%20hills%20at%20sunset%2C%20warm%20inviting%20light%2C%20peaceful%20lifestyle%20key%20art%2C%20vertical%20composition&width=500&height=750&seq=sh-s4-91peach&orientation=portrait",
  },
  {
    id: "s5",
    title: "奔跑吧少年",
    year: "2025",
    type: "show",
    category: "竞技",
    region: "中国大陆",
    director: "姚译添",
    actors: ["李晨", "郑恺", "白鹿"],
    rating: "8.0",
    tags: ["竞技", "青春", "户外"],
    description:
      "一群活力满格的少年在各地的挑战任务中奔跑、协作、爆笑不断。汗水与笑声交织，记录下青春最真实、最热烈的一面。",
    cover:
      "https://readdy.ai/api/search-image?query=energetic%20outdoor%20game%20show%20poster%2C%20young%20people%20laughing%20and%20running%20on%20a%20sunny%20beach%20with%20colorful%20props%2C%20bright%20cheerful%20daylight%2C%20dynamic%20fun%20key%20art%2C%20vertical%20composition&width=500&height=750&seq=sh-s5-91peach&orientation=portrait",
  },
  {
    id: "s6",
    title: "天赐的声音",
    year: "2024",
    type: "show",
    category: "音乐",
    region: "中国大陆",
    director: "陈伟",
    actors: ["汪苏泷", "周深", "张碧晨"],
    rating: "8.4",
    tags: ["音乐", "合唱", "舞台"],
    description:
      "实力歌手两两搭档，用一次次改编与合唱碰撞出新的火花。舞台风格各异的声音彼此成就，让经典歌曲焕发出全新的生命力。",
    cover:
      "https://readdy.ai/api/search-image?query=singing%20duet%20show%20poster%2C%20two%20performers%20under%20dramatic%20beam%20lights%20on%20a%20circular%20stage%2C%20deep%20blue%20and%20silver%20lighting%2C%20elegant%20music%20show%20key%20art%2C%20vertical%20composition&width=500&height=750&seq=sh-s6-91peach&orientation=portrait",
  },
];